<script lang="ts" setup>
import { ref } from 'vue'
import {
    Document,
    Menu as IconMenu,
    Location,
    Setting,
    Switch,
    House,
    Files,
    EditPen,
    Finished,
    Select,
    Refrigerator,
    QuestionFilled
} from '@element-plus/icons-vue'
import { useAuthStore } from '@/stores/auth/Auth'

const authStore = useAuthStore()

const isCollapse = ref(false)

function openClose() {
    console.log('Clcik!')
    isCollapse.value = !isCollapse.value
}

const handleOpen = (key: string, keyPath: string[]) => {
    console.log(key, keyPath)
}
const handleClose = (key: string, keyPath: string[]) => {
    console.log(key, keyPath)
}
</script>

<template>
    <!--<el-aside :width="isCollapse ? '64px' : '220px'">
        <el-affix :offset="60">
            <el-menu default-active="3" class="el-menu-vertical-demo left-main-menu" :collapse="isCollapse"
                @open="handleOpen" @close="handleClose" :collapse-transition="false">
                <el-menu-item index="1">
                    <el-icon>
                        <House />
                    </el-icon>
                    <template #title>Home</template>
                </el-menu-item>
                <el-sub-menu index="2">
                    <template #title>
                        <el-icon>
                            <Files />
                        </el-icon>
                        <span class="w-100">
                            <el-badge :value="9" type="info">
                                <span>Campaigns</span>
                            </el-badge>
                        </span>
                    </template>
                    <el-menu-item-group>
                        <template #title>Campaign Management</template>
                        <el-menu-item index="1-1" class="">
                            <el-badge :value="3" type="info" class="w-100">
                                <el-icon>
                                    <EditPen />
                                </el-icon>
                                Draft
                            </el-badge>
                        </el-menu-item>
                        <el-menu-item index="1-2" class="">
                            <el-badge :value="1" type="info">
                                <el-icon>
                                    <Finished />
                                </el-icon>
                                Prepared
                            </el-badge>
                        </el-menu-item>
                        <el-menu-item index="1-3" class="">
                            <el-badge :value="1" type="info">
                                <el-icon><Select /></el-icon>
                                Active
                            </el-badge>
                        </el-menu-item>
                        <el-menu-item index="1-4" class="">
                            <el-badge :value="4" type="info">
                                <el-icon>
                                    <Refrigerator />
                                </el-icon>
                                Archived
                            </el-badge>
                        </el-menu-item>

                        <el-menu-item index="1-5" class="">
                            <el-icon>
                                <QuestionFilled />
                            </el-icon>
                            FAQ
                        </el-menu-item>
                    </el-menu-item-group>

                </el-sub-menu>
                <el-menu-item index="3">
                    <el-icon><icon-menu /></el-icon>
                    <template #title>Hive</template>
                </el-menu-item>
                <el-menu-item index="4">
                    <el-icon>
                        <document />
                    </el-icon>
                    <template #title>News</template>
                </el-menu-item>
                <el-menu-item index="5">
                    <el-icon>
                        <setting />
                    </el-icon>
                    <template #title>Setting</template>
                </el-menu-item>
                <el-menu-item index="6" @click="openClose">
                    <el-icon>
                        <Switch />
                    </el-icon>
                    <template #title>Open/Close Menu</template>
                </el-menu-item>
            </el-menu>
        </el-affix>
    </el-aside>-->

    <!--<el-main>-->
    <h1>Home Page news</h1>
    <!--<pre>
            Locked Down:{{ authStore.lockedDown }}
            initialized:{{ authStore.initialized }}
            lastActivity:{{ authStore.lastActivity }}
            persistentDetails: {{ authStore.persistentDetails }}
            user:{{ authStore.user }}
            companies:{{ authStore.companies }}
    </pre>-->

    <el-timeline class="time-line">
        <el-timeline-item center timestamp="2023/11/19" placement="top">
            <el-card>
                <h4>AI in sweeps stakes, yes! We made it!</h4>
                <p><el-image src="https://picsum.photos/id/119/600/200" /></p>
                <p>
                    There she is. See-Threepio, do you copy? For the moment. Uh, we're in the main
                    hangar across from the ship. We're right above you. Stand by. You came in that
                    thing? You're braver that I thought. Nice! Come on! It's them! Blast them! Get
                    back to the ship! Where are you going? Come back! He certainly has courage.
                </p>
                <p><el-image src="https://picsum.photos/id/160/200/300" /></p>
            </el-card>
        </el-timeline-item>
        <!--<can :roles="['CarRead']">
            <el-timeline-item center timestamp="2022/9/30" placement="top">
                <el-card>
                    <h4>We show you for the best statistics!</h4>
                    <p><el-image src="https://picsum.photos/id/171/600/200" /></p>
                    <p>
                        In a way, you have determined the choice of the planet that'll be destroyed
                        first. Since you are reluctant to provide us with the location of the Rebel
                        base, I have chosen to test this station's destructive power. on your home
                        planet of Alderaan. No! Alderaan is peaceful. We have no weapons. You can't
                        possibly. You would prefer another target? A military target? Then name the
                        system! I grow tired of asking this.
                    </p>
                </el-card>
            </el-timeline-item>
        </can>-->

        <el-timeline-item center timestamp="2022/6/11" placement="top">
            <el-card>
                <h4>Player manager is online!</h4>
                <p><el-image src="https://picsum.photos/id/60/600/200" /></p>
                <p>
                    I heartily agree with you sir. Negola dewaghi wooldugger?!? He doesn't like you.
                    I'm sorry. I don't like you either You just watch yourself. We're wanted men. I
                    have the death sentence in twelve systems.
                </p>
            </el-card>
        </el-timeline-item>

        <el-timeline-item center timestamp="2022/5/18" placement="top">
            <el-card>
                <h4>Administration panel now available!</h4>
                <p>
                    Did you hear that? They've shut down the main reactor. We'll be destroyed for
                    sure. This is madness! We're doomed! There'll be no escape for the Princess this
                    time. What's that? Artoo! Artoo-Detoo, where are you? At last! Where have you
                    been? They're heading in this direction. What are we going to do? We'll be sent
                    to the spice mine of Kessel or smashed into who knows what! Wait a minute, where
                    are you going? The Death Star plans are not in the main computer.
                </p>

                <p><el-image src="https://picsum.photos/id/117/600/200" /></p>
            </el-card>
        </el-timeline-item>

        <el-timeline-item center timestamp="2022/4/16" placement="top">
            <el-card>
                <h4>Prizific Just Lounched!</h4>
                <p>We are started the Prizific company, and we are prepared for the world!</p>
            </el-card>
        </el-timeline-item>
    </el-timeline>
    <!--</el-main>-->
</template>

<style lang="scss">
.time-line {
    //max-width: 900px;
}

.left-main-menu,
.el-menu--popup-container {
    .w-100 {
        width: 100%;
    }

    .el-badge {
        width: 100%;

        .el-badge__content {
            top: 10px;
        }
    }
}
</style>
